export const DEFAULT_EMPLOYER_VIEW_PORT = 3000;

export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  LOCAL: 'local',
  STAGING: 'staging',
  PRODUCTION: 'production',
} as const;

export const APP_THEMES = {
  REVERSE: 'reverse',
  AKI: 'aki',
} as const;
